module.exports = __webpack_public_path__ + "img/beach-walk-min.5f4b896f.jpg";